import { ServerFetch } from '../main-model'

export default class StockSettingUserModel extends ServerFetch {
    getStockSettingUserBy = (data) => this.authFetch({
        url: 'stock-setting-user/getStockSettingUserBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}